import { render, staticRenderFns } from "./announcementAudit.vue?vue&type=template&id=6cb0edf0&scoped=true"
import script from "./announcementAudit.vue?vue&type=script&lang=js"
export * from "./announcementAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb0edf0",
  null
  
)

export default component.exports